import { useAppSelector } from "../store/hooks";
import {
  createPlanViewStateKey,
  serializeKey,
} from "../store/realTimeUpdates/stateKeyUtils";
import { RootState } from "../store/index";
import { useMemo } from "react";
import { PlanViewStateEntryStatus } from "../store/realTimeUpdates/index";
import { shallowEqual } from "react-redux";
import { GanttTabBarTab } from "../types/ganttChart";
import { getSolutionType } from "../utils/fetchQueryUtil";
import { useSearchParams } from "react-router-dom";
import { PlanViewKey } from "./useQueryParams";

const DEFAULT_MISSING_STATE: SolutionOverviewSummary = {
  nexusStatus: "missing",
  pondooStatus: "missing",
};

export type OverviewKey = {
  filterId?: number;
  date?: string;
};

export type SolutionOverviewSummary = {
  nexusStatus: PlanViewStateEntryStatus;
  pondooStatus: PlanViewStateEntryStatus;
  idScenario?: number;
};

/**
 * Get the loading status of both solutions for the KPI overview page
 * @param keyParams
 */
export const useSolutionOverviewStatus = (keyParams: OverviewKey) => {
  const selector = useMemo(() => {
    return (state: RootState) => {
      // If we're missing any key components, return a default state
      if (!keyParams.filterId || !keyParams.date) {
        return DEFAULT_MISSING_STATE;
      }

      const nexusKey = createPlanViewStateKey(
        "NexusSolution",
        keyParams.filterId,
        keyParams.date
      );
      const pondooKey = createPlanViewStateKey(
        "PondooSolution",
        keyParams.filterId,
        keyParams.date
      );

      return {
        nexusStatus:
          state.realTimeUpdateSlice[serializeKey(nexusKey)]?.status ||
          DEFAULT_MISSING_STATE,
        pondooStatus:
          state.realTimeUpdateSlice[serializeKey(pondooKey)]?.status ||
          DEFAULT_MISSING_STATE,
        idScenario:
          state.realTimeUpdateSlice[serializeKey(nexusKey)]?.idScenario,
      } as SolutionOverviewSummary;
    };
  }, [keyParams.filterId, keyParams.date]);
  return useAppSelector(selector, shallowEqual);
};

export interface CreateViewKeyHookParams {
  selectedGanttChartTab: GanttTabBarTab;
  filter: string | null;
  date: string | null;
}
